import React from 'react';

const ELECTRODE_POSITIONS = {
    Fp1: { x: 42, y: 22 }, Fp2: { x: 78, y: 22 },
    F7:  { x: 21, y: 42 }, F3:  { x: 42, y: 42 }, Fz:  { x: 60, y: 42 }, F4:  { x: 78, y: 42 }, F8:  { x: 99, y: 42 },
    T3:  { x: 15, y: 65 }, C3:  { x: 39, y: 65 }, Cz:  { x: 60, y: 65 }, C4:  { x: 81, y: 65 }, T4:  { x: 105, y: 65 },
    T5:  { x: 24, y: 88 }, P3:  { x: 42, y: 88 }, Pz:  { x: 60, y: 88 }, P4:  { x: 78, y: 88 }, T6:  { x: 96, y: 88 },
    O1:  { x: 45, y: 105 }, O2:  { x: 75, y: 105 }
};

const BrainTopomap = ({ data, band, mode }) => {
    const lines = [];

    if (data) {
        const channels = Object.keys(ELECTRODE_POSITIONS);
        for (let i = 0; i < channels.length; i++) {
            for (let j = i + 1; j < channels.length; j++) {
                const chA = channels[i];
                const chB = channels[j];
                const pairKey = `${chA}_${chB}`;
                const reverseKey = `${chB}_${chA}`;
                
                const zScore = data[pairKey]?.[band] ?? data[reverseKey]?.[band];
                
                if (zScore !== undefined) {
                    const absZ = Math.abs(zScore);
                    
                    // Amplitude Asymmetry də daxil olmaqla bütün xətt (network) xəritələri üçün həssaslıq limiti
                    const threshold = 0.5;

                    if (absZ >= threshold) {
                        const strokeColor = zScore > 0 ? '#ef4444' : '#2563eb';
                        const strokeWidth = absZ >= 2.5 ? 2.5 : (absZ >= 1.5 ? 1.5 : 0.8);

                        lines.push({
                            id: `${chA}_${chB}_${band}`,
                            x1: ELECTRODE_POSITIONS[chA].x, y1: ELECTRODE_POSITIONS[chA].y,
                            x2: ELECTRODE_POSITIONS[chB].x, y2: ELECTRODE_POSITIONS[chB].y,
                            color: strokeColor,
                            width: strokeWidth
                        });
                    }
                }
            }
        }
    }

    return (
        // viewBox sabit 120x120 qalır, style ilə 100% sığdırılır
        <svg viewBox="0 0 120 120" style={{ width: '100%', height: '100%', display: 'block', margin: 'auto' }}>
            <circle cx="60" cy="65" r="51" fill="#eaab94" stroke="#cbd5e1" strokeWidth="1" />
            <path d="M 54 14 L 60 6 L 66 14" fill="#e7cf88" stroke="#cbd5e1" strokeWidth="1" strokeLinejoin="round" />
            
            {lines.map(line => (
                <line
                    key={line.id}
                    x1={line.x1} y1={line.y1}
                    x2={line.x2} y2={line.y2}
                    stroke={line.color}
                    strokeWidth={line.width}
                    strokeLinecap="round"
                    opacity="0.85"
                />
            ))}

            {Object.keys(ELECTRODE_POSITIONS).map(ch => (
                <circle key={`net-dot-${ch}`} cx={ELECTRODE_POSITIONS[ch].x} cy={ELECTRODE_POSITIONS[ch].y} r="2" fill="#475569" />
            ))}
        </svg>
    );
};

export default BrainTopomap;